import { h } from './dom.js';

/**
 * Generic "nothing to show" placeholder. Used for empty filter results,
 * missing ingestion data, error states, and the 404 screen.
 */
export function EmptyState({ title, message, action, headingLevel = 'h2', headingId = null }) {
  const headingTag = /^h[1-6]$/.test(headingLevel) ? headingLevel : 'h2';
  return h('div', { class: 'lib-empty-state' },
    h(headingTag, {
      class: 'lib-empty-state-title',
      ...(headingId ? { id: headingId } : {}),
    }, title),
    message ? h('p', { class: 'lib-empty-state-message' }, message) : null,
    action ? action : null,
  );
}
